export const trackEvent = (name, category, label) => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, {
        event_category: category,
        event_label: label,
      });
    }
  };
  